<template>
    <div style="width: 100%;scroll-behavior: smooth;">
        <!-- <Header /> -->
        <!-- <button @click="toHeight('four')">点击</button>
        <a href="#two" style="transition: all .5s ease-in;">tiaozhuan</a> -->
        <div class="top-bottom">
            <img src="../../assets/img/home/home-banner.png" @click="toImgDetail" alt="">
        </div>
        <div class="content">
            <div class="one" id="one">
                <div class="title-style">
                    <div class="text-bg">METERED SERVICES</div>
                    <div class="text">计量服务</div>
                </div>
                <div class="sub-content">
                    <div class="item">
                        <!-- :style="{backgroundImage: 'url(' + require('@/assets/img/home/jiliangfuwu1.png') + '); background-size: cover;'}" -->
                        <div class="item-content" @click="toLegislation" >
                            <div class="item-title" >
                                <div class="desc">计量法律法规</div>
                                <div class="icon"><i class="el-icon-right"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-content" @click="toJiliangnengli">
                            <div class="item-title">
                                <div class="desc">计量能力</div>
                                <div class="icon"><i class="el-icon-right"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="item-content" @click="toJiliangService">
                            <div class="item-title">
                                <div class="desc">计量服务方案</div>
                                <div class="icon"><i class="el-icon-right"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="two" id="two">
                <div class="title-style">
                    <div class="text-bg">STANDARDIZED SERVICES</div>
                    <div class="text">标准化服务</div>
                </div>
                <div class="sub-content">
                    <div class="list">
                        <div class="item" @click="toBiaozhunhuaLegislation">
                            <img src="../../assets/img/home/biaozhun1.png" alt="">
                            <div class="item-title">标准化法律法规</div>
                        </div>
                        <div class="item" @click="toBiaozhunchaxun">
                            <img src="../../assets/img/home/biaozhun2.png" alt="">
                            <div class="item-title">标准查询</div>
                        </div>
                        <div class="item" @click="toBiaozhunService('xiuding')">
                            <img src="../../assets/img/home/biaozhun3.png" alt="">
                            <div class="item-title">标准制修订服务</div>
                        </div>
                        <div class="item" @click="toBiaozhunService('xiangmujianshe')">
                            <img src="../../assets/img/home/biaozhun4.png" alt="">
                            <div class="item-title">标准化项目建设服务</div>
                        </div>
                        <div class="item" @click="toBiaozhunService('shangpintiaoma')">
                            <img src="../../assets/img/home/biaozhun5.png" alt="">
                            <div class="item-title">商品条码服务</div>
                        </div>
                    </div>
                    <div class="two-bottom">
                        <img src="../../assets/img/home/biaozhun-bottom.png" class="bottom-img" alt="">

                        <div class="bottom-content">
                            <img src="../../assets//img/home/biaozhun-bottom-text.png" class="text-img" alt="">
                            <div class="bottom-item">
                                <div class="desc" @click="toRenzhengjianyanLegislation">认证检验检测政策法规</div>
                                <!-- <div class="desc">检验检测能力信息查询</div> -->
                                <a href="http://218.57.139.17:9900/JYJCWEB/" class="desc" target="_blank">检验检测能力信息查询</a>
                                <!-- <div class="desc">认证规则要求</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="three">
                <div class="title-style">
                    <div class="text-bg">INSPECTION AND TESTING SERVICES</div>
                    <div class="text">检验检测服务</div>
                </div>
                <div class="sub-content">
                    <div class="list">
                        <div class="one-item" @click="toJiancenengli">
                            <div class="one-style">
                                <div class="item-title">
                                    <div class="desc">检测能力</div>
                                    <div class="icon"><i class="el-icon-right"></i></div>
                                </div>
                            </div>
                            
                        </div>
                        <!-- <div class="item" v-for="(item, index) in jianceZizhiList" :key="item.id">
                            <el-image :src="downloadUrl + item.photo" :preview-src-list="[downloadUrl + item.photo]" class="item-img"></el-image>
                        </div>  -->
                        <div class="item plus" v-for="(item, index) in jianceZhijianList" :key="item.id" @click="toJianceZhijianDetail(item)">
                            <img :src="downloadUrl + item.photo" class="item-img" alt="">
                            <div class="desc">{{item.name}}</div>
                        </div>
                    </div>
                    <div class="list" style="margin-top: 20px;">
                        <div class="one-item" @click="toJianceService">
                            <div class="one-style">
                                <div class="item-title">
                                    <div class="desc">检测服务方案</div>
                                    <div class="icon"><i class="el-icon-right"></i></div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="item pro" v-for="(item, index) in jianceServiceList" :key="item.id" @click="toJianceServiceDetail(item)">
                            <div class="photo-info">
                                <img :src="downloadUrl + item.photo" alt="" class="item-img">
                                <div class="img-text">{{item.title}}</div>
                            </div>
                            <div class="info">
                                <div class="info-box">
                                    <img src="../../assets/img/home/jianyanjiance-icon.png" class="icon" alt="">
                                    <div class="text">{{item.type}}</div>
                                </div>
                                <div class="info-box" style="margin-top: 10px;">
                                    <img src="../../assets/img/home/jianyanjiance-icon2.png" class="icon" alt="">
                                    <div class="text">{{item.provider}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="three">
                <div class="title-style">
                    <!-- <div class="text-bg">ONE-STOP SERVICE STATION</div> -->
                    <!-- <div class="text" style="top: -5px;">检验临淄厨具质量基础设施一站式服务站</div> -->
                    <div class="text-bg">ZIBO CITY QUALITY INFRASTRUCTURE SERVICE PLATFORM (STATION)</div>
                    <div class="text" style="top: -5px;">淄博市质量基础设施服务平台（站）</div>
                </div>
                <div class="sub-content">
                    <!-- <div class="list" style="margin-top: 20px;">
                        <div class="one-item" @click="toChujuService()">
                            <div class="one-style2">
                                <div class="item-title">
                                    <div class="desc">新闻资讯</div>
                                    <div class="icon"><i class="el-icon-right"></i></div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="item pro small" @click="toChujuService('行业动态')">
                            <div class="photo-info">
                                <img src="../../assets/img/chuju/main_item1.png" alt="" class="item-img">
                                <div class="img-text">行业动态</div>
                            </div>
                            <div class="info" style="padding-top: 0;">
                                <div class="info-box" style="display: flex;flex-direction: column;">
                                    <div class="text one-line-ellipsis" style="padding: 8px 0;line-height: 30px;" v-for="item in hangye" @click="toDetail(item,'行业动态')">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="item pro small" @click="toChujuService('厨具新闻')">
                            <div class="photo-info">
                                <img src="../../assets/img/chuju/main_item2.png" alt="" class="item-img">
                                <div class="img-text">厨具新闻</div>
                            </div>
                            <div class="info" style="padding-top: 0;">
                                <div class="info-box" style="display: flex;flex-direction: column;">
                                    <div class="text one-line-ellipsis" style="padding: 8px 0;line-height: 30px;"  v-for="item in news" @click="toDetail(item,'厨具新闻')">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="item pro small" @click="toChujuService('能力提升')">
                            <div class="photo-info">
                                <img src="../../assets/img/chuju/main_item3.png" alt="" class="item-img">
                                <div class="img-text">能力提升</div>
                            </div>
                            <div class="info" style="padding-top: 0;">
                                <div class="info-box" style="display: flex;flex-direction: column;">
                                    <div class="text one-line-ellipsis" style="padding: 8px 0;line-height: 30px;"  v-for="item in nengli" @click="toDetail(item,'能力提升')">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="scroll-out-wrap"  @mouseenter="pauseScroll" @mouseleave="startAutoScroll">
                        <div class="arrow left" @click="scrollLeft">&lt;</div>
                        <!-- Element横向滚动 -->
                        <el-scrollbar ref="scrollBar" class="scroll-main" horizontal>
                            <div class="scroll-inner">
                            <!-- 第一组 两行网格 -->
                            <div class="grid-group">
                                <div class="card-grid">
                                <div
                                    class="card-item"
                                    v-for="(item, idx) in allChainList"
                                    :key="idx"
                                    :style="{backgroundColor:item.bgcolor}"
                                    @click="clickCard(item)"
                                >
                                    <!-- <span class="icon" v-html="item.icon"></span> -->
                                    <span class="name">{{ item.name }}</span>
                                </div>
                                </div>
                            </div>
                            </div>
                        </el-scrollbar>
                        <div class="arrow right" @click="scrollRight">&gt;</div>
                        </div>
                </div>
            </div>
            <div class="four" id="four">
                <div class="title-style">
                    <div class="text-bg">QUALITY SERVICE</div>
                    <div class="text">质量服务</div>
                </div>

                <div class="sub-content">
                    <img src="../../assets/img/home/zhiliang-left.png" class="left" @click="toQualityLegislation" alt="">
                    <div class="right">
                        <img src="../../assets/img/home/zhiliang-right-top.png" @click="toQualityBrand" class="right-img" alt="" />
                        <a href="https://msa.zibo.gov.cn/col/col9717/index.html" target="_blank">
                            <img src="../../assets/img/home/zhiliang-right-bottom.png" class="right-img" alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "./header.vue";
import Vue from "vue";
import vueMiniPlayer from "vue-mini-player";
import "vue-mini-player/lib/vue-mini-player.css";
Vue.use(vueMiniPlayer);

import ScrollItem from "./scrollItem.vue";

import { Server } from "@/server";
import { Link } from "element-ui";

export default {
    name: "home",
    data() {
        return {
            
            downloadUrl:'',

            articleList: [],

            jianceZizhiList: [], // 检测-资质证书列表
            jianceZhijianList: [], // 检测-质检中心列表

            jianceServiceList: [], // 检测服务方案列表

            hangye:[],
            news:[],
            nengli:[],
            // 17条产业链数据（包含截图8个，补齐至17个）
            allChainList: [],
            scrollSpeed: 320, // 单次滚动距离（单个卡片宽度）
            timer: null,
            isPause: false, // 新增：是否到达末尾暂停标记
        };
    },
    
    components: {
        ScrollItem,
        Header
    },
    created() {
        this.$store.state.CommonHeader.tab = 0
        this.getJianceList()
        this.getChujuList()
        this.getNQIQYList()
    },
    beforeDestroy() {
        this.pauseScroll()
    },
    methods: {
        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            // return color;
            return '#7FBEF2'
        },
        getNQIQYList() {
            Server.getNQIQYList({pageSize:-1}).then(res => {
                if (res.success) {
                    console.log(res);
                    this.allChainList = res.result.records
                }
            })
        },
        pauseScroll() {
            console.log(12345);
            
            clearInterval(this.timer)
        },
        scrollLeft() {
            this.$refs.scrollBar.wrap.scrollLeft -= 330*3+10
        },
        scrollRight() {
            this.$refs.scrollBar.wrap.scrollLeft += 330*3+10
        },
        startAutoScroll() {
            return
            clearInterval(this.timer)
            const dom = this.$refs.scrollBar.wrap
            const singleWidth = dom.scrollWidth / 2
            // 临界值提前一点，留出完整展示空间
            const threshold = singleWidth + 320// - 300

            this.timer = setInterval(() => {
                if (this.isPause) return
                dom.scrollLeft += 1.2
                // 到达距离末尾还有一个卡片宽度时暂停
                if ((dom.scrollLeft + 20) >= threshold) {
                    this.isPause = true
                    setTimeout(() => {
                        dom.scrollLeft = 0
                        this.isPause = false
                    }, 1500)
                }
            }, 80)
        },
        clickCard(item) {
            console.log('点击产业链：', item.name)
            if (item.outsidechain) {
                window.open(item.outsidechain,'_blank')
            }
            else if (item.website) {
                this.$router.push({
                    path: item.website
                })
            } else {
                this.$router.push({
                    path: '/NQIDetail'
                })
            }
        },
        getChujuList() {
            Server.getMainChujuItem().then(res => {
                console.log(res);
                if(res.success) {
                    res.result.forEach(item => {
                        switch(item.typeName) {
                            case '行业动态':
                            this.hangye = item.children;
                            break;
                            case '厨具新闻':
                            this.news = item.children;
                            break;
                            case '能力提升':
                            this.nengli = item.children;
                            break;
                        }
                    })
                }
            })
        },
        getJianceList() {
            // Server.getJianyanjianceInfo({type: 1}).then(res => {
            //     console.log(res);
            //     if(res.success) {
            //         this.jianceZizhiList = res.result.records.slice(0,2)
            //     }
                
            // })
            Server.getJianyanjianceInfo({type: 2}).then(res => {
                console.log(res);
                if(res.success) {
                    this.jianceZhijianList = res.result.records.slice(0,4)
                }
            })
            Server.getCheckServerList().then(res => {
                console.log(res);
                if(res.success) {
                    this.jianceServiceList = res.result.records.slice(0, 4)
                }
                console.log(this.jianceServiceList);
                
                
            })
        },
        toJiancenengli() {
            this.$router.push({
                path: '/jiancenengli',
                query: {

                }
            })
        },
        toJianceService() {
            this.$router.push({
                path: '/jianyanService',
                query: {

                }
            })
        },
        toChujuService(name) {
          this.$store.state.CommonHeader.tab = 9
            this.$router.push({
                path: '/chujuSub',
                query:{
                    typename:'新闻资讯',
                    isMMain:true,
                    showName:name
                }
            })
        },
        toDetail(item,name) {
          this.$store.state.CommonHeader.tab = 9
          this.$router.push({
              path: '/cjContentDetail',
              query:{
                id:item.id,
                isMain:false,
                isShow:true,
                typename:'新闻资讯',
                showName:name
              }
          })
        },
        toJianceZhijianDetail(item) {
            this.$router.push({
                path: '/jiancenengliDetail',
                query: {
                    id: item.id
                }
            })
        },
        toJianceServiceDetail(item) {
            this.$router.push({
                path: 'jianyanServiceDetail',
                query: {
                  id: item.id
                },
            })
        },

        toLegislation() {
            this.$router.push({
                path: 'legislationService',
                query: {

                },
            })
        },

        toJiliangnengli() {
            this.$router.push({
                path: 'jiliangnengli',
                query: {

                }
            })
        },

        toJiliangService() {
            this.$router.push({
                path: 'jiliangService',
                query: {

                }
            })
        },
        toBiaozhunhuaLegislation() {
            this.$router.push({
                path: '/biaozhunhuaLegislation'
            })
        },

        toBiaozhunchaxun() {
            this.$router.push({
                path: '/biaozhunchaxun'
            })
        },
        toBiaozhunService(info) {
            this.$router.push({
                path: '/biaozhunService',
                query: {
                    pageType: info
                }
            })
        },

        toRenzhengjianyanLegislation() {
            this.$router.push({
                path: '/renzhengjianyanLegislation'
            })
        },

        toImgDetail() {
            this.$router.push({
                path: '/imgDetail'
            })
        },
        toQualityLegislation() {
            this.$router.push({
                path: '/qualityLegislation'
            })
        },
        toQualityBrand() {
            this.$router.push({
                path: '/qualityBrand'
            })
        }
    },

    mounted() {
        //获取贸促动态
        // this.getmcdt();
        
        // this.$store.state.CommonHeader.tab = 0;
        // this.imgList = [];
        
        // this.startAutoScroll()
        this.downloadUrl = this.$downloadUrl
    },
};
</script>

<style lang="less" scoped>
// body, html {
//     scroll-behavior: smooth;
// }
:deep(.el-scrollbar__wrap--horizontal) {
  padding-right: 20px;
}
.industry-chain-box {
  width: 100%;
  padding: 40px 0;
}
/* 标题 1:1原图样式 */
.title-wrap {
  text-align: center;
  margin-bottom: 36px;
}
.cn-title {
  font-size: 36px;
  color: #222;
  display: inline-flex;
  align-items: center;
  gap: 16px;
  margin: 0;
}
.short-line {
  width: 60px;
  height: 3px;
  background: #2468e8;
}
.en-title {
  font-size: 20px;
  color: #999;
  margin: 8px 0 0;
  letter-spacing: 1px;
}

/* 外层滚动容器 */
.scroll-out-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.arrow {
  width: 40px;
  height: 120px;
  background: #eeeeee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #333;
  cursor: pointer;
  border-radius: 4px;
  user-select: none;
}
.arrow:hover {
  background: #dddddd;
}
.scroll-main {
  flex: 1;
}
/* 横向滚动外层：两组网格并排 */
.scroll-inner {
  display: flex;
  gap: 0;
  width: max-content; /* 新增 */
}
.grid-group {
  flex-shrink: 0;
}
/* 核心：单数组自动两行，每行4个 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(9, 325px);
  gap: 10px;
}
/* 卡片完全匹配原图尺寸、圆角、布局 */
.card-item {
  width: 325px;
  height: 100px;
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
}
.icon {
  width: 48px;
  height: 48px;
  display: block;
}
.name {
  font-size: 15px;
  color: #ffffff;
  font-weight: 500;
  padding: 10px;
  text-align: center;
}


.top-bottom {
    width: 100%;
    height: 350px;
    img {
        width: 100%;
        height: 100%;
    }
}
.content {
width: 1100px;
margin: 40px auto 0;


    .header-banner {
        width: 100%;
        height: 336px;
    }
    .title-style {
        text-align: center;
        letter-spacing: 2px;
        .text-bg {
            font-family: SourceHanSansCN-Bold;
            font-weight: bold;
            color: #DDD;
            font-size: 24px;
        }
        .text {
            position: relative;
            top: -12px;
            font-size: 22px;
            font-weight: bold;
        }
    }
    .one {
        .sub-content {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .item {
                width: 32%;
                height: 200px;
                border-radius: 5px;

                overflow: hidden;
                .item-content {
                    width: 100%;
                    height: 100%;
                    background-image: url(../../assets/img/home/jiliangfuwu1.png);
                    background-size: 100% 100%;

                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #fff;
                    .item-title {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .desc {
                            font-size: 18px;
                            font-weight: bold;
                            letter-spacing: 1px;
                        }
                        .icon {
                            width: 35px;
                            height: 35px;
                            border: 2px solid #fff;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            font-weight: bold;
                            font-size: 30px;
                            margin-top: 15px;
                        }
                    }
                    &:hover {
                        transform: scale(1.1);
                        transition: all .5s ease-in-out;
                    }
                }
                &:nth-child(2) {
                    .item-content {
                        background-image: url(../../assets/img/home/jiliangfuwu2.png);
                    }
                }
                &:nth-child(3) {
                    .item-content {
                        background-image: url(../../assets/img/home/jiliangfuwu3.png);
                    }
                }
            }
        }
    }
    .two {
        margin-top: 40px;
        .sub-content {
            margin-top: 20px;
            
            .list {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                align-items: center;
                .item {
                    width: 32%;
                    height: 80px;
                    margin: 5px 10px;
                    position: relative;

                    cursor: pointer;
                    img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                    }
                    .item-title {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        color: #fff;
                        font-weight: bold;
                        letter-spacing: 1px;

                        z-index: 100;
                        position: relative;
                    }
                    &:nth-child(3n) {
                        margin-right: 0;
                    }
                    &:nth-child(3n+1) {
                        margin-left: 0;
                    }
                }
                
            }
            .two-bottom {
                margin-top: 30px;
                position: relative;
                .bottom-img {
                    width: 100%;

                    position: absolute;
                    top: 0;
                }
                .bottom-content {
                    width: 100%;
                    height: 220px;

                    // padding-top: 80px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;

                    position: relative;
                    z-index: 10;
                    .text-img {
                        width: 250px;
                    }
                    .bottom-item {
                        width: 60%;
                        margin: 10px auto 0;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        
                        .desc {
                            width: 290px;
                            height: 70px;
                            background-image: url(../../assets/img/home/biaozhun-item-bg.png);
                            background-size: 100% 100%;

                            color: #1168DB;
                            font-weight: bold;
                            cursor: pointer;

                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    }
                }
            }
        }
    }
    .three {
        margin-top: 60px;
        width: 100%;
        .sub-content {
            margin-top: 20px;
            .list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 240px;
                .one-item {
                    width: 19%;
                    height: 100%;
                    overflow: hidden;
                    .one-style {
                        width: 100%;
                        height: 100%;
                        background-image: url(../../assets/img/home/jianyanjiance-list1.png);
                        background-size: 100% 100%;

                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        &:hover {
                            transform: scale(1.05);
                            transition: all .5s ease-in-out
                        }
                    }

                    .one-style2 {
                        width: 100%;
                        height: 100%;
                        background-image: url(../../assets/img/chuju/main_title.png);
                        background-size: 100% 100%;

                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        &:hover {
                            transform: scale(1.05);
                            transition: all .5s ease-in-out
                        }
                    }
                    
                    .item-title {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .desc {
                            font-size: 24px;
                            font-weight: bold;
                            letter-spacing: 1px;
                        }
                        .icon {
                            width: 30px;
                            height: 30px;
                            border: 2px solid #fff;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            font-weight: bold;
                            font-size: 26px;
                            margin-top: 20px;
                        }
                    }
                }
                .item {
                    width: 19.5%;
                    height: 100%;

                    background-color: #fff;
                    padding: 10px 15px;
                    box-sizing: border-box;
                    .item-img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .item.plus {
                    .item-img {
                        height: 60%;
                        margin-bottom: 10px;
                    }
                    .desc {
                        padding-top: 15px;
                        border-top: 1px solid #ccc;
                        text-align: center;
                        font-weight: bold;
                        line-height: 22px;
                    }
                }
                .item.pro {
                    height: 100%;
                    .photo-info {
                        height: 65%;
                        .item-img {
                            height: 70%;
                            width: 100%;
                            background-color: #f5f5f5;
                        }
                        .img-text {
                            margin: 15px 0;
                            font-weight: bold;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    .info {
                        padding-top: 15px;
                        border-top: 1px solid #ccc;
                        .info-box {
                            display: flex;
                            
                            .icon {
                                width: 15px;
                                height: 15px;
                            }
                            .text {
                                margin-left: 10px;
                                flex: 1;
                            }
                        }
                    }
                }
                .item.pro.small {
                    width: 26%;
                }
                &:nth-child(2) {
                    .one-style {
                        background-image: url(../../assets/img/home/jianyanjiance-list2.png);
                    }
                }
            }
        }
    }
    .four {
        margin: 40px 0;
        .sub-content {
            margin-top: 20px;

            display: flex;
            justify-content: space-between;
            align-items: center;

            height: 180px;
            .left {
                width: 60%;
                height: 100%;
            }
            .right {
                height: 100%;
                width: 39%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .right-img {
                    width: 100%;
                    height: 49%;
                }
                a {
                    width: 100%;
                    height: 49%;
                    .right-img {
                        height: 100%;
                    }
                }
            }
        }
    }
    
}
:deep(.el-carousel__arrow.el-carousel__arrow--left) {
    display: none;
}
:deep(.el-carousel__arrow.el-carousel__arrow--right) {
    display: none;
}

/* pad */
@media screen and (max-width: 1199px) and (min-width: 600px) {
    .content {
        .two {
            .img {
                padding: 0;
                .img {
                    width: 330px;
                    height: 130px;
                    cursor: pointer;
                    padding: 0;
                }
            }
        }
        .three {
            .con {
                .div {
                    .img {
                        width: 300px;
                        height: 226px;
                    }
                }
            }
        }
    }
}


:deep(.el-carousel__indicators--horizontal) {
    position: relative;
    // top: 15px;
    text-align: center;
}


      .one-line-ellipsis {
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        line-height: 1.2em;
        max-height: 2.4em;
      }
</style>
